import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { t } from '@insight/toolkit-utils/lib/labels';
import { Icon } from '../Icon';

const SimpleStockInfo = ({
  children,
  unlimited,
  showLimitedStockQty,
  stock,
  showBackOrder = false,
  isPDP = false,
}) => {
  let description = '';
  let iconProps = { icon: 'checkmark-circled', type: 'success' };
  const maxStock = 9999;
  const maxStockDisplay = stock > maxStock ? maxStock : stock;
  if (unlimited) {
    description = t('In stock');
    iconProps = { icon: 'checkmark-circled', type: 'success' };
  } else if (stock > 10) {
    description = isPDP
      ? `${t('In stock')}: ${maxStockDisplay} ${t('available')}`
      : t('In stock');
    iconProps = { icon: 'checkmark-circled', type: 'success' };
  } else if (stock !== 0 && stock <= 10 && showLimitedStockQty) {
    description = `${t('Only')} ${stock} ${t('left in stock')}`;
    iconProps = { icon: 'alert', type: 'info' };
  } else if (stock !== 0 && stock <= 10) {
    description = isPDP
      ? `${t('Only')} ${stock} ${t('left in stock')}`
      : t('Limited stock');
    iconProps = { icon: 'alert', type: 'info' };
  } else if (showBackOrder) {
    description = t('Item backordered');
    iconProps = { icon: 'alert', type: 'error' };
  } else {
    description = isPDP ? t('Item backordered') : t('Out of stock');
    iconProps = { icon: 'alert', type: 'error' };
  }
  return (
    <>
      <span className={`o-grid o-grid--center c-stock--${iconProps.type}`}>
        <span className="o-grid__item o-grid__item--shrink c-stock__icon">
          <span className="o-grid o-grid--full-height">
            {iconProps.icon ? <Icon size="small" {...iconProps} /> : null}
          </span>
        </span>
        <span className="o-grid__item o-grid__item--shrink u-text-bold">
          {description}
        </span>
      </span>
      {children}
    </>
  );
};

export default SimpleStockInfo;

SimpleStockInfo.propTypes = {
  unlimited: PropTypes.bool,
  /** Show the limited availability text (Only {quantity} left in stock) */
  showLimitedStockQty: PropTypes.bool,
  /** Available stock quantity */
  stock: PropTypes.number.isRequired,
};

SimpleStockInfo.defaultProps = {
  unlimited: false,
  showLimitedStockQty: false,
};
